
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form12";
const form12State = namespace("Form12");

import Form12ProcessHeader from "@/components/process/Form12/components/Form12ProcessHeader.vue";
import { packageInfoType } from '@/types/Information';
import { form12StatusInfoType } from '@/types/Information/Form12';

@Component({
    components:{
        Form12ProcessHeader
    }
})
export default class SubmitForm12 extends Vue {

    @form12State.State
    public currentOrderToVarySingleJusticeId: string;

    stepsCompleted = {} as form12StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public savePdf(){        
        const pdfType = "FORM"
        const pdfName ="Form12"
        const url = '/form12/form-print/'+this.currentOrderToVarySingleJusticeId+'/?pdf_type='+pdfType
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);          

        },err => {
            console.error(err);
        });
    }   

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
